import { useState, useEffect } from "react";

const useSubscriptionPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/packages`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch subscription packages');
      }

      const data = await response.json();
      setPackages(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  const refetch = () => {
    fetchPackages();
  };

  return {
    packages,
    loading,
    error,
    refetch
  };
};

export default useSubscriptionPackages; 